const skills = {
  js: {
    name: 'JavaScript',
    level: 5,
  },
  writing: {
    name: 'Technical Writing',
    level: 5,
  },
  py: {
    name: 'Python',
    level: 5,
  },
  html: {
    name: 'HTML/CSS',
    level: 5,
  },
  react: {
    name: 'React.js',
    level: 4,
  },
  git: {
    name: 'Git',
    level: 4,
  },
  d3: {
    name: 'D3.js',
    level: 5,
  },
  three: {
    name: 'THREE.jS',
    level: 4,
  },
  torch: {
    name: 'Pytorch',
    level: 4,
  },
  numpy: {
    name: 'pandas/numpy/scipy',
    level: 5,
  },
  matlab: {
    name: 'matlab',
    level: 4,
  },
  flask: {
    name: 'flask',
    level: 3,
  },
  CC: {
    name: 'C++',
    level: 3,
  },
  C: {
    name: 'C',
    level: 3,
  },
  java: {
    name: 'Java',
    level: 3,
  },
  CS: {
    name: 'C#',
    level: 3,
  },
  Lisp: {
    name: 'Lisp',
    level: 3,
  },
}

export default skills